module.exports = __webpack_public_path__ + "static/media/IMG-11.06f360c8.jpg";